export default "__VITE_ASSET__BUn6IKzc__"